import { cn } from '@lair-finance/util'
import { forwardRef } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { MENU_LIST } from '@/domains/header/config'
import { DialogClose } from '@/shared/ui/Dialog'

export const MenuModal = forwardRef<HTMLDivElement, { className?: string }>(({ className }, ref) => {
  const location = useLocation()

  return (
    <div
      className={cn(
        'relative inline-flex flex-col w-screen h-full bg-greyscale-700 p-5 sm:py-6 overflow-x-hidden overflow-y-auto invisible-scrollbar',
        className,
      )}
      ref={ref}
    >
      {MENU_LIST.map(item => {
        const active = item.isActive(location.pathname)

        return (
          <DialogClose key={item.name} asChild>
            <Link className={cn('flex items-center min-h-[64px]', className)} to={item.path}>
              <span className={cn('inline-flex text-greyscale-300 typo-label-2 md:typo-label-1', { 'text-greyscale-100': active })}>{item.name}</span>
              {item.isNew && (
                <span className={'ml-2 inline-flex-center px-1 h-4 rounded-[4px] bg-primary-500 text-greyscale-50 typo-label-3'}>New</span>
              )}
            </Link>
          </DialogClose>
        )
      })}
    </div>
  )
})
MenuModal.displayName = 'MenuModal'
